function StepsNavbar({ currentStep, setStep, next }) {

  const steps = [
    { stepNumber: "01", stepName: "Project Description" },
    { stepNumber: "02", stepName: "Contributor Information" },
    { stepNumber: "03", stepName: "License Information" },
    { stepNumber: "04", stepName: "File Attachment" },
    { stepNumber: "05", stepName: "Submit Project" },
  ]

  /**
   * Changes the step of the submit data page.
   * @param {*} index Index of the step that the user wants to switch to
   */
  function changeStep(index) {
    if (currentStep > (index + 1)) {
      setStep(index + 1)
    }
    if ((currentStep + 1) === (index + 1)) {
      next();
    }
  }

  /**
   * Creates a chevron shape to be used as right border between step components.
   * @returns Chevron shaped border
   */
  function renderArrowBorder() {
    return (
      <svg
        className="h-full w-full text-gray-300"
        viewBox="0 0 22 80"
        fill="none"
        preserveAspectRatio="none"
      >
        <path
          d="M0 -2L20 40L0 82"
          vectorEffect="non-scaling-stroke"
          stroke="currentcolor"
          strokeLinejoin="round"
        />
      </svg>
    )
  }

  return (
    <>
      <div className="bg-white dark:bg-gray-900">
        <div className="max-w-7xl mx-auto py-8 px-4 sm:py-12 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="mt-1 font-bold text-gray-900 dark:text-gray-100 text-2xl sm:text-5xl sm:tracking-tight lg:text-5xl mb-4">
              Metadata Information
            </h1>
            <p className="max-w-xl mx-auto text-md text-gray-500 dark:text-gray-400 mb-0">
              Please submit your metadata and fill all the required fields in
              order to proceed
            </p>
          </div>
        </div>
      </div>
      <div className="dark:bg-gray-900">
      <nav aria-label="Progress" className="xl:mx-24 md:mx-14 mx-4">
        <ol className="border border-gray-300 dark:border-gray-600 rounded-md divide-y divide-gray-300 dark:divide-gray-600 lg:flex lg:divide-y-0 overflow-hidden">
          {steps.map((step, index) => {
            if (currentStep < parseInt(step.stepNumber)) {
              /* UPCOMING STEP ------------------------------------------------------------------------------------------- */
              return (
                <li onClick={() => changeStep(index)} key={parseInt(step.stepNumber)} className="cursor-pointer relative md:flex-1 md:flex dark:bg-gray-800">
                  <span className="group flex items-center">
                    <span className="px-6 py-4 flex items-center text-sm font-medium">
                      <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-gray-300 dark:border-gray-600 rounded-full group-hover:border-gray-400 dark:group-hover:border-gray-500">
                        <span className="text-gray-500 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-gray-300">
                          {step.stepNumber}
                        </span>
                      </span>
                      <span className="ml-4 text-sm font-medium text-gray-500 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-gray-300">
                        {step.stepName}
                      </span>
                    </span>
                  </span>
                  {steps.length !== parseInt(step.stepNumber) ?
                    <div className="hidden lg:block absolute top-0 right-0 h-full w-5" aria-hidden="true">
                      {renderArrowBorder()}
                    </div>
                    : <></>}
                </li>
              )
            }
            if (currentStep > parseInt(step.stepNumber)) {
              /* COMPLETED STEP ------------------------------------------------------------------------------------------- */
              return (
                <li onClick={() => changeStep(index)} key={parseInt(step.stepNumber)} className="cursor-pointer relative md:flex-1 md:flex dark:bg-gray-800">
                  <span className="group flex items-center w-full">
                    <span className="px-6 py-4 flex items-center text-sm font-medium">
                      <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-blue-600 rounded-full group-hover:bg-blue-800">
                        {/*  Heroicon name: check  */}
                        <svg
                          className="w-6 h-6 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </span>
                      <span className="ml-4 text-sm font-medium text-gray-900 dark:text-gray-200 group-hover:text-gray-900 dark:group-hover:text-gray-300">
                        {step.stepName}
                      </span>
                    </span>
                  </span>

                  {steps.length !== parseInt(step.stepNumber) ?
                    <div className="hidden lg:block absolute top-0 right-0 h-full w-5" aria-hidden="true">
                      {renderArrowBorder()}
                    </div>
                    : <></>}
                </li>
              )
            } else {
              /* CURRENT STEP ------------------------------------------------------------------------------------------- */
              return (
                <li key={parseInt(step.stepNumber)} className="cursor-pointer relative md:flex-1 md:flex dark:bg-gray-800">
                  <span className="px-6 py-4 flex items-center text-sm font-medium">
                    <span
                      className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-blue-600 rounded-full"
                      aria-current="step"
                    >
                      <span className="text-blue-600">{step.stepNumber}</span>
                    </span>
                    <span className="ml-4 text-sm font-medium text-blue-600">
                      {step.stepName}
                    </span>
                  </span>

                  {steps.length !== parseInt(step.stepNumber) ?
                    <div className="hidden lg:block absolute top-0 right-0 h-full w-5" aria-hidden="true">
                      {renderArrowBorder()}
                    </div>
                    : <></>}
                </li>
              )
            }
          })
          }
        </ol>
      </nav>
      </div>
    </>
  );
}

export default StepsNavbar;